import type { FaireProductEntity } from "../../entity_types/product";

export const p_enta2bhht7: FaireProductEntity = {
  token: "p_enta2bhht7",
  type: "product",
  name: "Thanks! Thanks! Thanks! Letterpress Greeting Card",
  brandToken: "b_4cdthxubt5",
  brandName: "Half Pint Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f768a25a5e2af0cb89a5af8b6d9a7e3f15673adcf917337f91a40c573c718976.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Letterpress printed greeting card\n\n- Bright Red ink \n- Size: 4-Bar (3.5 x 4.875")\n- Blank on the inside\n- Printed on ecru cotton paper\n- Comes with 30% post-consumer waste kraft colored envelope\n\nAll cards come in a biodegradable protective cellophane wrap\n\nMade in Salt Lake City. Printed with our hands!\nHand lettered by Allison Cornu-Bitzer',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:16.465Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
